import React from 'react'
import { CheckMinimumPrice } from '../../../Services/ProductService'
import { useConfig } from '../../../Providers/ConfigProvider'

const useCheckPrice = () => {
    const { api } = useConfig()

    const handleCheckMinimumPrice = async (custId, artNo, priceNet) => {
        try {
            const res = await CheckMinimumPrice(api, custId, artNo, priceNet)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    return { handleCheckMinimumPrice }
}

export default useCheckPrice